// plugins/refresh-token.js
export default defineNuxtPlugin((nuxtApp) => {
    const handleRefreshToken = () => {
        const refreshToken = useCookie("refresh_token");
        const tokenExpireTime = useCookie("token_expires_in");
        const baseUrl = `${useRuntimeConfig().public.baseURL}/auth/token/refresh`;
        const isPending = ref(false); // Check if API call is pending or not

        const checkAndHandleRefreshToken = async () => {
            const timeLeftUntilAccessTokenExpires = _timeLeftUntilAccessTokenExpires();
            // const timeLeftUntilAccessTokenExpires = 30;

            if (!refreshToken.value || !timeLeftUntilAccessTokenExpires) return false; // If refreshToken or tokenExpireTime doesn't exist, we can't call refreshToken
            if (timeLeftUntilAccessTokenExpires < 48 && !isPending.value) {
                // If token will expire in less than 48 hours, call refreshToken

                try {
                    isPending.value = true;
                    const res = await $fetch(baseUrl, {
                        method: "POST",
                        body: { refresh_token: refreshToken.value },
                    });
                    if (res) {
                        updateCookies(res);
                        return Promise.resolve(res);
                    }
                } catch (e) {
                    isPending.value = false;
                }
            }
            return false; // Return false if token is not expired or API call is pending
        };

        const _timeLeftUntilAccessTokenExpires = () => {
            if (!tokenExpireTime.value) return null;
            const currentDate = new Date();
            const differenceInMilliseconds = +tokenExpireTime.value - currentDate.getTime();
            const differenceInHours = +differenceInMilliseconds / (1000 * 60 * 60);
            return differenceInHours;
        };

        const updateCookies = (res) => {
            useCookie("access_token", { maxAge: res.expires_in }).value = res.access_token;
            useCookie("refresh_token", { maxAge: res.refresh_expires_in }).value = res.refresh_token;
            const currentDate = new Date();
            const futureTimestamp = currentDate.getTime() + res.expires_in * 1000;
            useCookie("token_expires_in", { maxAge: res.refresh_expires_in }).value = String(
                futureTimestamp.toString()
            );
        };

        return { checkAndHandleRefreshToken };
    };

    nuxtApp.hook("app:mounted", async () => {
        const { checkAndHandleRefreshToken } = handleRefreshToken();
        await checkAndHandleRefreshToken();
    });

    return {
        provide: {
            handleRefreshToken,
        },
    };
});
